export { Edit2 as default } from './Edit2';
